"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MODAL_SECONDS_TIMEOUT = exports.MODAL_MINUTES_TIMEOUT = exports.OTHERS_TIMEOUT = exports.STUDENTS_TIMEOUT = void 0;
exports.STUDENTS_TIMEOUT = 3420000; // 58 minutes 3480000
exports.OTHERS_TIMEOUT = 42900000; // 11 hours 55 minutes
exports.MODAL_MINUTES_TIMEOUT = 2;
exports.MODAL_SECONDS_TIMEOUT = 0;
